// externals
import type { Reducer } from 'redux';

// libraries
import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import type { SelectedOffer } from '@makemydeal/dr-shared-types';

// consts/enums
import { OFFER_SAVE_SUCCESS, SELECTED_OFFER_SET } from '../actionTypes/selectedOfferActionTypes';
import { BOOTSTRAP_INITIAL_LOAD, BOOTSTRAP_SUCCESS } from '../actionTypes/bootstrapActionTypes';
import { INIT_PENCIL_SUCCESS } from '../actionTypes/initActionTypes';

export type SelectedOfferReducer = Reducer<SelectedOffer>;

export const reducer: SelectedOfferReducer = (state: SelectedOffer = {} as unknown as SelectedOffer, action: any) => {
    switch (action.type) {
        case SELECTED_OFFER_SET: {
            const offer: SelectedOffer = {
                ...state,
                ...action.payload
            };

            return offer;
        }
        case BOOTSTRAP_INITIAL_LOAD: {
            // read the values from SessionStorage
            const ids = offerSessionUtils.getOfferIdentifiers();

            // Load them into state
            const offer: SelectedOffer = { ...ids };
            return offer;
        }
        case INIT_PENCIL_SUCCESS:
        case BOOTSTRAP_SUCCESS: {
            // get the settings from the initial load
            const { offer } = action.payload;
            if (offer) {
                const { connectionId, dealExchangeDealId: dealXgId, dealExchangeVersionId: dealXgVersion, vehicle } = offer;

                const selectedOffer: SelectedOffer = {
                    connectionId,
                    dealXgId,
                    dealXgVersion,
                    vin: vehicle?.vin
                };
                return selectedOffer;
            }

            return state;
        }
        case OFFER_SAVE_SUCCESS: {
            const dealXgId = action.payload?.dealXgId;
            const dealXgVersion = action.payload?.dealXgVersion;
            const selectedOffer: SelectedOffer = {
                ...state,
                ...(dealXgId && { dealXgId }),
                ...(dealXgVersion && { dealXgVersion })
            };

            return selectedOffer;
        }
        default: {
            return state;
        }
    }
};
